import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-document-type-details-tabs',
  templateUrl: './document-type-details-tabs.component.html',
  styleUrls: ['./document-type-details-tabs.component.scss'],
})
export class DocumentTypeDetailsTabsComponent implements OnInit {
  @Input() modelId: number | string;

  tabs: any[] = [
    {
      title: 'Details',
      template: 'details',
    },
  ];

  constructor() {}

  ngOnInit() {}
}
